const Loader = ({
  size = 60,
  speed = 3,
  text = 'Loading...',
}: {
  size: number;
  speed: number;
  text?: string;
}) => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }}>
    <svg width={size} height={size} viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
      {/* Outer circle group (rotates clockwise) */}
      <g>
        {/* Four alternating arc segments */}
        <path d="M100,10 A90,90 0 0,1 190,100" stroke="red" strokeWidth="15" fill="none" />
        <path d="M190,100 A90,90 0 0,1 100,190" stroke="black" strokeWidth="15" fill="none" />
        <path d="M100,190 A90,90 0 0,1 10,100" stroke="red" strokeWidth="15" fill="none" />
        <path d="M10,100 A90,90 0 0,1 100,10" stroke="black" strokeWidth="15" fill="none" />
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 100 100"
          to="360 100 100"
          dur={`${speed}s`}
          repeatCount="indefinite"
        />
      </g>
      {/* Inner dotted circle group (rotates anticlockwise) */}
      <g>
        <circle
          cx="100"
          cy="100"
          r="70"
          stroke="red"
          strokeWidth="5"
          fill="none"
          strokeDasharray="10 10"
        />
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 100 100"
          to="-360 100 100"
          dur={`${speed}s`}
          repeatCount="indefinite"
        />
      </g>
      {/* Fixed logo inside */}
      <g transform="translate(100,100) scale(3)">
        <g transform="translate(-14,-9)">
          <path
            d="M14.6246 18C14.6206 15.7106 14.6183 13.4211 14.6126 11.1311C14.6108 10.4255 14.6028 9.71992 14.5891 9.01433C14.5856 8.84283 14.6292 8.70516 14.7342 8.56745C16.3014 6.51323 17.8634 4.45553 19.4278 2.39958C19.9876 1.66359 20.5487 0.92874 21.108 0.192173C21.1527 0.133087 21.2193 0.0849004 21.221 0H21.3357C21.5497 0.43999 21.9002 0.780164 22.1945 1.15992C23.7789 3.20442 25.3742 5.23972 26.9655 7.27846C27.1651 7.53434 27.343 7.80968 27.5627 8.04659C27.8931 8.40283 28.0015 8.79978 27.9987 9.28626C27.9826 12.0851 27.9969 14.8839 28.0004 17.6828C28.0004 17.7201 27.9958 17.7573 27.9883 17.8623C27.7015 17.4992 27.4451 17.1785 27.1938 16.8544C25.275 14.3808 23.3555 11.9078 21.4418 9.43082C21.3156 9.26731 21.2612 9.28053 21.1413 9.43999C19.4886 11.625 17.8296 13.8043 16.1712 15.9853C15.7088 16.5928 15.2447 17.1992 14.7841 17.8078C14.7411 17.8646 14.6613 17.9071 14.6831 18H14.6246Z"
            fill="#EC1D25"
          />
          <path
            d="M6.70997 0C7.04266 0.534642 7.46546 1.00102 7.84979 1.49665C9.49214 3.61514 11.1247 5.74108 12.8038 7.83032C13.2409 8.37473 13.3947 8.91623 13.3884 9.59774C13.3631 12.1367 13.3901 14.6757 13.397 17.2152C13.397 17.4155 13.397 17.6151 13.397 17.891C11.1471 14.9952 8.93057 12.1419 6.687 9.25469C4.48594 12.1442 2.29975 15.0147 0.113582 17.8853C0.017783 17.8021 0.0590859 17.6896 0.0590859 17.5904C0.0562174 16.5642 0.058512 15.5379 0.0550701 14.5116C0.0550701 14.4124 0.096373 14.3005 0 14.2168C0 12.3822 0 10.5477 0 8.71376C0.535213 8.02079 1.07387 7.33068 1.60507 6.63484C3.0151 4.78596 4.4234 2.93652 5.82654 1.08305C6.09328 0.730257 6.39905 0.40385 6.59639 0.000573653H6.71112L6.70997 0Z"
            fill="#EC1D25"
          />
        </g>
      </g>
    </svg>
    {/* Text below loader */}
    <p
      style={{
        margin: 0,
        fontSize: '16px',
        color: '#333',
        textAlign: 'center',
        fontFamily: 'inherit',
      }}>
      {text}
    </p>
  </div>
);

export default Loader;
